import { render, staticRenderFns } from "./attrLabelSet.vue?vue&type=template&id=a33d1d82&scoped=true&"
import script from "./attrLabelSet.vue?vue&type=script&lang=js&"
export * from "./attrLabelSet.vue?vue&type=script&lang=js&"
import style0 from "./attrLabelSet.vue?vue&type=style&index=0&id=a33d1d82&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33d1d82",
  null
  
)

export default component.exports